class CountdownTimer extends HTMLElement {
  constructor() {
    super();
    this.endDate = this.dataset.endDate;
    this.daysElement = this.querySelector('[data-days]');
    this.hoursElement = this.querySelector('[data-hours]');
    this.minutesElement = this.querySelector('[data-minutes]');
    this.secondsElement = this.querySelector('[data-seconds]');

    if (!this.endDate) {
      console.warn('No end date provided for countdown timer');
      return;
    }

    this.targetDate = new Date(this.endDate).getTime();
    this.interval = null;
    this.initializeTimer();
  }

  initializeTimer() {
    // Update immediately
    this.updateTimer();

    // Then update every second
    this.interval = setInterval(() => {
      this.updateTimer();
    }, 1000);
  }

  updateTimer() {
    const now = new Date().getTime();
    const distance = this.targetDate - now;

    // If the countdown is finished, clear interval
    if (distance < 0) {
      clearInterval(this.interval);
      this.updateDisplay(0, 0, 0, 0);
      return;
    }

    // Time calculations for days, hours, minutes and seconds
    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    this.updateDisplay(days, hours, minutes, seconds);
  }

  updateDisplay(days, hours, minutes, seconds) {
    if (this.daysElement) {
      this.daysElement.textContent = String(days).padStart(2, '0');
    }
    if (this.hoursElement) {
      this.hoursElement.textContent = String(hours).padStart(2, '0');
    }
    if (this.minutesElement) {
      this.minutesElement.textContent = String(minutes).padStart(2, '0');
    }
    if (this.secondsElement) {
      this.secondsElement.textContent = String(seconds).padStart(2, '0');
    }
  }

  disconnectedCallback() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }
}

customElements.define('countdown-timer', CountdownTimer);
